import * as React from "react";
import { Model } from "@flowable/forms";
import { connect } from "react-redux";
import Study from "./Study";
import StudySearch from "./StudySearch";
import styles from "./IRBStudy.css";
import { request } from "utils/proxy";

class IRBStudy extends Model.StatefulFormComponent {
	constructor (props) {
		super(props);
		this.state = {
			studies: []
		};
	}

	componentDidMount () {
		this.loadStudies();
	}

	loadStudies () {
		const initialValue = this.props.config.value || [];
		if (initialValue.length === 0) {
			return;
		}
		const allStudyIds = initialValue.join("&studyIds=");
		request(`/sp/api/studies?studyIds=${allStudyIds}`)
			.then(studies => {
				this.setState({ studies });
				this.onSave(studies);
			});
	}

	addStudies (newStudies) {
		const { studies } = this.state;
		let updatedStudies = [ ...studies, ...newStudies ];
		this.setState({ studies: updatedStudies });
		this.onSave(updatedStudies);
	}

	removeStudy (index) {
		let studies = [ ...this.state.studies ];
		studies.splice(index, 1);
		this.setState({ studies });
		this.onSave(studies);
	}

	onSave = payload => {
		const { onChange } = this.props;
		this.dispatchFocusEvent();
		onChange(this.cleanupPayload(payload));
	}

	cleanupPayload (listOfStudies) {
		return listOfStudies.map(study => study.number);
	}

	render () {
		const { dictionary } = this.props;
		const disabled = this.props.config.enabled === false;
		const bem = this.bem("panel", { disabled });

		return (
			<div className={bem("")}>
				<div className={bem("")}>
					<h2>{dictionary?.headline || "Link to Cayuse IRB Study"}</h2>
					<p>{dictionary?.description || "Please select a study that you wish to link to this proposal"}</p>
				</div>
				{this.state.studies.length > 0 ? (<div className={`ui cards ${styles.cardMargin}`}>
					{this.state.studies.map((value, index) => (
						<Study key={`study-${index}`} study={value} close={() => this.removeStudy(index)}/>
					))}
				</div>) : ""}
				<div>
					<StudySearch {...this.props} addStudies={study => this.addStudies(study)}/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	dictionary: state.dictionary.irbStudy
});

export default connect(mapStateToProps)(IRBStudy);
